import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Btn } from "../components/Btn";
import { UserAvatar } from "../components/UserAvatar";
import { useIsDesktop } from "../lib/useIsDesktop";

export function Account() {
  const { user, signOut } = useAuth();
  const nav = useNavigate();
  const isDesktop = useIsDesktop();
  if (!user) return null;

  return (
    <div style={{ padding: isDesktop ? "48px 64px 80px" : "20px 22px 32px" }}>
      <div style={{ maxWidth: 640, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 28 }}>
          <UserAvatar first={user.first} last={user.last} size={64} />
          <div>
            <h1 style={{ margin: 0, fontFamily: "var(--display)", fontSize: isDesktop ? 32 : 26, fontWeight: 400, letterSpacing: -0.6 }}>
              {user.first} {user.last}
            </h1>
            <div style={{ fontSize: 13, color: "var(--ink-soft)", marginTop: 4 }}>{user.email}</div>
          </div>
        </div>

        <Btn variant="secondary" onClick={() => nav("/my-pledge")}>View my pledge</Btn>{" "}
        <Btn variant="ghost" onClick={() => { signOut(); nav("/"); }} style={{ marginLeft: 8 }}>Sign out</Btn>
      </div>
    </div>
  );
}
